import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import ReactNotify from 'react-notify';
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import KonfiguracjaHeader from "../../../../shared/headers/KonfiguracjaHeader";
import PrzystankiForm from "./components/PrzystankiForm";
import PrzystankiTable from "./components/PrzystankiTable";
import {TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";
import PrzystankiService from "./PrzystankiService";
import MiejscowosciService from "../miejscowosci/MiejscowosciService";
import PokazNaMapie from "./googleMapComponents/PokazNaMapie";
import ScrollUtilities from "../../../../utilities/ScrollUtilities";

export default class PrzystankiContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            miejscowosci: [],
            przystanki: [],
            przystanek: null,
            pokazFormularz: false,
            wlaczSzukanie: true,
            pokazMape:false,
        };
        this.pobierzPrzystanki = this.pobierzPrzystanki.bind(this);
        this.pobierzMiejscowosci = this.pobierzMiejscowosci.bind(this);
        this.pokazFormularz = this.pokazFormularz.bind(this);
        this.zamknijFormularz = this.zamknijFormularz.bind(this);
        this.onClickEdytuj = this.onClickEdytuj.bind(this);
        this.onClickUsun = this.onClickUsun.bind(this);
        this.onClickZapisz = this.onClickZapisz.bind(this);
        this.onClickZmienNaDomyslny = this.onClickZmienNaDomyslny.bind(this);
        this.onClickPokazNaMapie = this.onClickPokazNaMapie.bind(this);
        this.zamknijMape = this.zamknijMape.bind(this);
    }

    componentDidMount() {
        this.pobierzPrzystanki()
        this.pobierzMiejscowosci()
    }

    pobierzPrzystanki() {
        PrzystankiService.getPrzystanki().then(function (response) {
            this.setState({przystanki: response.data.content})
        }.bind(this))
    }

    pobierzMiejscowosci() {
        MiejscowosciService.getMiejscowosci().then(function (response) {
            this.setState({miejscowosci: response.data.content})
        }.bind(this))
    }

    pokazFormularz() {
        this.setState({pokazFormularz: true})
        ScrollUtilities.scrollToTop()
    }

    zamknijFormularz() {
        this.setState({pokazFormularz: false, przystanek: null})
    }

    onClickEdytuj(obj) {
        this.pokazFormularz();
        this.setState({przystanek: obj})
    }

    onClickUsun(obj) {

        if (window.confirm('Czy usunąc przystanek: ' + obj.nazPr + ' w miejscowości ' + obj.nazMi)) {
            PrzystankiService.deletePrzystanek(obj.idPr).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie usunięto przystanek", "", 3000);
                    this.pobierzPrzystanki();
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas usuwania przystanku ", "", 3000);
                }
            }.bind(this))
        }
    }

    onClickZapisz(obj, czyEdycja) {

        if (czyEdycja) {
            PrzystankiService.editPrzystanek(this.state.przystanek.idPr, obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie edytowano przystanek", "", 3000);
                    this.pobierzPrzystanki();
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas edycjii przystanku ", "", 3000);
                }
            }.bind(this))

        }
        else {
            PrzystankiService.addPrzystanek(obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie dodano przystanek", "", 3000);
                    this.pobierzPrzystanki();
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas dodawania przystanku ", "", 3000);
                }
            }.bind(this))
        }
        this.zamknijFormularz();
    }

    onClickZmienNaDomyslny(obj, czyDomyslny) {
        let przystanek = obj;
        przystanek.domyslny = czyDomyslny
        PrzystankiService.editPrzystanek(przystanek.idPr, przystanek).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success("Pomyślnie ustawiono domyślnośc przystanku", "", 3000);
                this.pobierzPrzystanki();
            }
            else {
                this.refs.notificator.error("Wystąpił błąd podczas edycjii przystanku ", "", 3000);
            }
        }.bind(this))
    }

    onClickPokazNaMapie(obj) {
        this.setState({przystanek: obj,pokazMape:true})
    }

    zamknijMape(){
        this.setState({przystanek:null,pokazMape:false})
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history} collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'PrzystankiContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-trasami',
                                    text: 'Zarządzanie trasami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-trasami/przystanki', text: 'Przystanki'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <TopIf isTrue={!Boolean(this.state.pokazFormularz) && !Boolean(this.state.pokazMape)}>
                                <KonfiguracjaHeader pokazFormularz={this.pokazFormularz}
                                                    tekstDodaj={'Dodaj przystanek'}
                                                    pokazButtonSzukaj={false}
                                />
                            </TopIf>
                            <TopIf isTrue={this.state.pokazMape}>
                                <div>
                                    {Boolean(this.state.przystanek) ?
                                        <PokazNaMapie przystanek={this.state.przystanek}
                                                      handleZamknijMape={this.zamknijMape}/>
                                        :
                                        ''
                                    }
                                </div>
                            </TopIf>
                            <TopIf isTrue={Boolean(this.state.pokazFormularz) && (this.state.miejscowosci.length > 0)}>
                                <PrzystankiForm handleClickZapisz={this.onClickZapisz}
                                                handleClickAnuluj={this.zamknijFormularz}
                                                miejscowosci={this.state.miejscowosci}
                                                przystanek={this.state.przystanek}
                                />
                            </TopIf>
                            <TopIf isTrue={Boolean(this.state.pokazFormularz) && !(this.state.miejscowosci.length > 0)}>
                                <TopAlertUwaga text={'Nie można wyświetlić formularza do dodawania przystanku - brak miejscowości w bazie'}/>
                            </TopIf>
                            <TopIf isTrue={Boolean(this.state.przystanki)}>
                                <PrzystankiTable data={this.state.przystanki}
                                                 wlaczSzukanie={this.state.wlaczSzukanie}
                                                 handleEdytuj={this.onClickEdytuj}
                                                 handleUsun={this.onClickUsun}
                                                 handleZmienNaDomyslny={this.onClickZmienNaDomyslny}
                                                 pokazNaMapie={this.onClickPokazNaMapie}
                                />
                            </TopIf>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/przystanki/PrzystankiContainer.js